import React from "react";
import { VariantProps } from ".";
import Price from "../Price";
import PlusMemberDiscount from "../PlusMemberDiscount";
const G = ({
  selectedProduct,
  user,
  productListingView
}: VariantProps) => {
  const {
    price,
    unitOfMeasure,
    activeSale
  } = selectedProduct;
  const mapPrice = price.minimumAdvertisedPriceProperties.price;
  const applyPlusPricing = () => {
    let applyMemberDiscount = price.minimumAdvertisedPriceOverride.priceLevel5 > 0 && price.minimumAdvertisedPriceOverride.priceLevel5 < price.price && price.minimumAdvertisedPriceOverride.priceLevel5 < mapPrice;
    if (applyMemberDiscount && activeSale) {
      applyMemberDiscount = price.minimumAdvertisedPriceOverride.priceLevel5 < price.salePrice;
    }
    return applyMemberDiscount;
  };
  return applyPlusPricing() ? <PlusMemberDiscount productListingView={productListingView} selectedProduct={selectedProduct} user={user} data-sentry-element="PlusMemberDiscount" data-sentry-component="G" data-sentry-source-file="G.tsx" /> : <Price {...{
    unitOfMeasure
  }} price={mapPrice} data-sentry-element="Price" data-sentry-component="G" data-sentry-source-file="G.tsx" />;
};
export default G;